(() => {const lpRoot=()=>document.getElementById('nt3-sp-lp103');const lpDocument={querySelector:s=>{const r=lpRoot();return r?(r.matches(s)?r:r.querySelector(s)):null},querySelectorAll:s=>{const r=lpRoot();return r?r.querySelectorAll(s):[]},getElementById:id=>{const r=lpRoot();return r?r.querySelector('[id="'+CSS.escape(id)+'"]'):null},get body(){return lpRoot()}};
(function () {
  let pendingFrame = null;
  let resizeTimer = null;

  function update() {
    pendingFrame = null;
    const element = lpDocument.getElementById('listicle-sticky-cta');
    if (!element) return;
    const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
    element.classList.toggle('listicle-sticky-cta--visible', window.innerWidth < 1024 && scrollPercentage > 10);
  }

  function schedule() {
    if (pendingFrame === null) pendingFrame = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(schedule, 100);
  });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  schedule();
})();

})();